/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

// Fix: sync product gallery image on color variant change
document.addEventListener('change', function(e) {
  if (!e.target.matches('.color-swatches input.product-option')) return;
  const color = e.target.value;
  const variant = window.productVariants?.find(v => v.option1 === color);
  if (!variant?.featured_media) return;
  const url = new URL(window.location);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url);
  window.dispatchEvent(new CustomEvent('variantChange.shopiweb.product', { detail: variant }));
});